import { useIsInternalUser } from 'app/hooks/use-is-internal-user/useIsInternalUser';
import { useAppSelector } from 'app/redux/store';
import { useEffect } from 'react';

export const useHeapDetermineInternalUsers = () => {
  const { details } = useAppSelector(state => state.profile.user);
  const { email } = details ?? {};
  const isInternal = useIsInternalUser();
  useEffect(() => {
    if (!window.heap) return;
    if (!email) return;
    window.heap.addUserProperties({
      Is_Internal: isInternal,
    });
  }, [email, isInternal]);
};
